/**
 *--------------- AUTHENTICATION EVENTS ---------------
 */

/**
 * Event triggered when a user enters in their email or phone number to begin the signup or login process
 */
export const signupLoginEmailPhoneEntered = 'signupLoginEmailPhoneEntered'

/**
 * Event triggered when verification code is entered
 */
export const verificationCodeEntered = 'verificationCodeEntered'

/**
 * The page name sent to posthog analytics for the signup or login page
 */
export const signupOrLoginPage = 'signup-or-login'

/**
 * The page name sent to posthog analytics for the user name onboarding page
 */
export const userNamePage = 'user-name-onboarding'

/**
 * The page name sent to posthog analytics for the verification page
 */
export const codeVerificationPage = 'code-verification'

/**
 * Event triggered when a user enters in their name during the onboarding process
 */
export const userNameEntered = 'userNameEntered'

/**
 * Event triggered when a user clicks on the view loadboard button and modal opens
 */
export const loadboardOpened = 'loadboardOpened'
